import Body from './Body/Body';
import Header from './Header/Header';
import { MODAL_CONTROL_ACTIONS } from 'src/utils/enums/user-store-actions.enum';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    ADD_NEW_USER_MODAL_CONTENT,
    ADD_NEW_USER_MODAL_LABEL_BUTTON_CANCEL,
    ADD_NEW_USER_MODAL_LABEL_BUTTON_CONFIRM,
    ADD_NEW_USER_MODAL_TITLE,
} from 'src/localization/resouceKeys';
import {
    DealerAssociation,
    DealerPermission,
} from 'src/services/models/dealer-management.service';
import React, { Dispatch, SetStateAction, useEffect } from 'react';

import './styles.scss';

interface INewUserProps {
    backClick: Dispatch<SetStateAction<boolean>>;
    setSuccessNotification: Dispatch<SetStateAction<boolean>>;
    dealerPermissions: Array<DealerPermission>;
    dealerAssociations: Array<DealerAssociation>;
    isDSMSearch?: boolean;
}

const NewUser: React.FC<INewUserProps> = ({
    backClick,
    setSuccessNotification,
    dealerPermissions,
    dealerAssociations,
    isDSMSearch = false,
}) => {
    const dispatch = useDispatch();
    const { i18n, t } = useTranslation();

    const handleActiveModal = () => {
        dispatch({
            type: MODAL_CONTROL_ACTIONS.SET_ACTIVE,
            payload: {
                titleContent: t(ADD_NEW_USER_MODAL_TITLE),
                bodyContent: t(ADD_NEW_USER_MODAL_CONTENT),
                cancelBtnLabel: t(ADD_NEW_USER_MODAL_LABEL_BUTTON_CANCEL),
                confirmBtnLabel: t(ADD_NEW_USER_MODAL_LABEL_BUTTON_CONFIRM),
                onCancelHandler: cancelhandler,
                onConfirmHandler: confirmHandler,
            },
        });
    };

    useEffect(() => {
        handleActiveModal();
    }, []);

    useEffect(() => {
        i18n.on('languageChanged', handleActiveModal);

        return () => {
            i18n.off('languageChanged', handleActiveModal);
        };
    }, []);

    const headerBackClickHandler = () => {
        dispatch({
            type: MODAL_CONTROL_ACTIONS.SET_SHOW,
            payload: {
                shouldShow: true,
                onCancelHandler: cancelhandler,
                onConfirmHandler: confirmHandler,
            },
        });
    };

    const cancelhandler = () => {
        dispatch({
            type: MODAL_CONTROL_ACTIONS.SET_SHOW,
            payload: { shouldShow: false },
        });
    };

    const confirmHandler = () => {
        dispatch({
            type: MODAL_CONTROL_ACTIONS.SET_INACTIVE,
        });
        backClick(false);
    };

    return (
        <div className={'new-user-container'}>
            <Header backClickHandler={headerBackClickHandler} />
            <Body
                backClickHandler={confirmHandler}
                setSuccessNotification={setSuccessNotification}
                dealerPermissions={dealerPermissions}
                dealerAssociations={dealerAssociations}
                isDSMSearch={isDSMSearch}
            />
        </div>
    );
};

export default NewUser;
